import Cookies from 'universal-cookie';
import { ApiSkiConfig, Config } from '../Config';
import { addToCartToAddItemToShoppingCart, getShoppingCartToCheckCartConverter } from "./cart.js";
import tr from './tr';
var sha1 = require('sha1');
let cookies = new Cookies();
let access_token = cookies.get('access_token');


// parse objet to uri params string
// @return string : URI formatted params
export function objectToURIParams(obj) {
  var str = "";
  for (var key in obj) {
    if (str == "") {
      str = (!Config.publish) ? "?" : "&";
      // str = '?';
    } else {
      str += "&";
    }
    str += key + "=" + encodeURIComponent(obj[key]);
  }
  return str;
}

function objectToURIParams1(obj) {
  var str = "";
  for (var key in obj) {
    if (str == "") {
      str = "?";
    } else {
      str += "&";
    }
    str += key + "=" + encodeURIComponent(obj[key]);
  }
  return str;
}

export function createCCInsertionUrl(that, access_token, params) {
  params.portal = Config.portal;
  params.platform = Config.platform;
  params.language = Config.language;
      params.version = Config.version;
  let url = Config.hostUrl + 'payment/createCCInsertionUrl' + objectToURIParams(params);
  return fetch(
    url,
    {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + access_token,
        timeout: Config.timeoutFetch,
      },
    }
  ).then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
    .catch(e => {
      console.log('error creating CC insertion url',e);
    });
}

async function fetchData(url, requestOptions, timeout = 10000) {
  console.log("calling: ", url);

  const timeoutPromise = new Promise((_, reject) =>
    setTimeout(() => reject(new Error('Request timed out')), timeout)
  );

  try {
    const response = await Promise.race([fetch(url, requestOptions), timeoutPromise]);
    console.log('fetch response:', response);
    const checkedResponse = await checkStatus(response);
    return checkedResponse;
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

export async function validateCoupon(that, voucher_code, totServices = 1, totReduced = 0) {
  const access_token = await cookies.get('access_token');
  const params = {
    voucher_code: voucher_code,
    renewing: 1,
    totServices: totServices,
    totReduced: totReduced,
    language: Config.language,
    portal: Config.portal,
  }
  let url = Config.hostUrl + 'service/validateVoucher' + objectToURIParams(params);

  return fetch(
    url,
    {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + access_token,
      },
    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
    .catch(e => {

      if (e.message.indexOf("Network request failed") >= 0) {
        return null;
      }
    });
}


export function getAllLatestContracts(that, access_token, params) {

  let url = Config.hostUrl + 'privacy/getAllLatestContracts' + objectToURIParams(params);
  console.log('calling rest @', url, params);

  return fetch(
    url,
    {
      method: 'GET',

      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + access_token,
      },

    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
    .catch(e => {
      if (e.message.indexOf("Network request failed") >= 0) {
        return null;
      }
    });


}

export function getLastSkierMovements(that, access_token, params) {
  params.portal = Config.portal;
  params.platform = Config.platform;
  params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
      params.version = Config.version;
  let url = Config.hostUrl + 'service/getLastSkierMovements' + objectToURIParams(params);
  console.log('calling rest @', url, params);

  return fetch(
    url,
    {
      method: 'GET',

      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + access_token,
      },

    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
    .catch(e => {
      //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
      // that.setState({isLoading: false});
      //console.log ('Network exception: ', e);

      if (e.message.indexOf("Network request failed") >= 0) {
        // DataManager.getInstance().setConnectionState(false);
        return null;
      }
    });


}


export function getUserResponses(that, access_token, params) {

  let url = Config.hostUrl + 'privacy/getUserResponses' + objectToURIParams(params);
  console.log('calling rest @', url, params);

  return fetch(
    url,
    {
      method: 'GET',

      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + access_token,
      },

    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
    .catch(e => {
      //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
      // that.setState({isLoading: false});
      //console.log ('Network exception: ', e);

      if (e.message.indexOf("Network request failed") >= 0) {
        // DataManager.getInstance().setConnectionState(false);
        return null;
      }
    });


}

export function searchForNewContracts(that, params) {

  let url = Config.hostUrl + 'privacy/searchForNewContracts' + objectToURIParams(params);
  console.log('calling rest @', url, params);

  return fetch(
    url,
    {
      method: 'GET',

      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + access_token,
      },

    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
    .catch(e => {
      //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
      // that.setState({isLoading: false});
      //console.log ('Network exception: ', e);

      if (e.message.indexOf("Network request failed") >= 0) {
        // DataManager.getInstance().setConnectionState(false);
        return null;
      }
    });


}

export function acceptContracts(that, access_token, params) {

  let url = Config.hostUrl + 'privacy/acceptContracts'
  console.log('calling rest @', url, access_token, params);

  // that.setState({isLoading: true});
  return fetch(
    url,
    {
      method: 'POST',

      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + access_token,
      },
      body: JSON.stringify(params),
    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
    .catch(e => {
      //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
      // that.setState({isLoading: false});
      console.log('Network exception: ', e);

      if (e.message.indexOf("Network request failed") >= 0) {
        // DataManager.getInstance().setConnectionState(false);
        return null;
      }
    });
}

export function updateContracts(that, access_token, params) {

  let url = Config.hostUrl + 'privacy/updateContracts'
  params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
  console.log('calling rest @', url, access_token, params);

  // that.setState({isLoading: true});
  return fetch(
    url,
    {
      method: 'POST',

      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + access_token,
      },
      body: JSON.stringify(params),
    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
    .catch(e => {
      //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
      // that.setState({isLoading: false});
      console.log('Network exception: ', e);

      if (e.message.indexOf("Network request failed") >= 0) {
        // DataManager.getInstance().setConnectionState(false);
        return null;
      }
    });
}

export const changePhoneNumber = async (that,phoneNumber, email) => {
  const params = {
    tel_cell: phoneNumber,
    email: email,
    one_step: 1,
    language: Config.language,
    portal: Config.portal,
  }
  const url = `${Config.hostUrl}users/changePhone${objectToURIParams(params)}`;
  const access_token = cookies.get('access_token');
  return fetch(
    url,
    {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${access_token}`
      },
      body: JSON.stringify(params),
    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
}

export function isPhoneNumberVerified(that) {
  const url = `${Config.hostUrl}users/isPhoneNumberVerified`;
  const access_token = cookies.get('access_token');
  return fetch(
    url,
    {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${access_token}`
      },
    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
    .catch(error => {
      console.error('Error checking phone verification:', error);
      return { status: 'fail', message: 'Failed to verify phone number status' };
    });
}

export function confirmSMS(that,phoneNumber, otp, email ) {
  const access_token = cookies.get('access_token');
  const params = {
    confirmSMSCode: otp,
    tel_cell: phoneNumber,
    email: email,
    one_step: 1,
    language: tr.userlng().toLowerCase(),
    portal: Config.portal,
    version: Config.version,
  }
  const url = `${Config.hostUrl}users/confirmSMS${objectToURIParams(params)}`;

  return fetch(
    url,
    {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${access_token}`
      },
      body: JSON.stringify(params),
    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      return response;
    })
}


export async function sendOTP(that,phoneNumber) {
  // Validate phone number before sending
  if (!phoneNumber || phoneNumber === 'undefined' || phoneNumber === 'null') {
    console.error('❌ sendOTP called without valid phone number:', phoneNumber);
    return {
      status: 'fail',
      message: 'Phone number is required'
    };
  }

  const params = {
    language: tr.userlng().toLowerCase(),
    portal: Config.portal,
    platform: Config.platform,
    version: Config.version,
    tel_cell: phoneNumber,
    one_step: 1
  }
  console.log('send otp params', params);
  const url = `${Config.hostUrl}users/sendCodeBySMS${objectToURIParams(params)}`;
  console.log('send otp url', url);
  const access_token = cookies.get('access_token');
  return fetch(
    url,
    {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${access_token}`
      },
      body: JSON.stringify(params),
    }
  )
    .then((response) => checkStatus(that, response))
    .then((response) => {
      console.log('send otp response', response);
      return response;
    })
    .catch(e => {
      console.log('error sending otp', e);
      return {
        status: 'fail',
        message: 'Error sending OTP'
      };
    });
  }

  export function sendCodeByEmail(that, params) {

    let url = Config.hostUrl + 'users/sendCodeByEmail'
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    console.log('calling rest @', url, params);

    // that.setState({isLoading: true});
    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
        // that.setState({isLoading: false});
        //console.log ('Network exception: ', e);

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });
  }

  export function recoverPassword(that, params) {

    let url = Config.hostUrl + 'users/recoverPassword'
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    console.log('calling rest @', url, params);

    // that.setState({isLoading: true});
    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
        // that.setState({isLoading: false});
        //console.log ('Network exception: ', e);

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });
  }

  export function checkCodeValidity(that, params) {

    let url = Config.hostUrl + 'users/checkCodeValidity'
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    console.log('calling rest @', url, params);

    // that.setState({isLoading: true});
    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
        // that.setState({isLoading: false});
        //console.log ('Network exception: ', e);

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });
  }
  export function modifyEmail(that, params) {

    let url = Config.hostUrl + 'users/modifyEmail'
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    console.log('calling rest @', url, params);

    // that.setState({isLoading: true});
    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
        // that.setState({isLoading: false});
        //console.log ('Network exception: ', e);

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });
  }

  export function changeEmail(that, params) {

    let url = Config.hostUrl + 'users/changeEmail'
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    console.log('calling rest @', url, params);

    // that.setState({isLoading: true});
    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
        // that.setState({isLoading: false});
        //console.log ('Network exception: ', e);

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });
  }


  export function sendWelcomeEmail(that, params) {
    // params.portal = Config.portal;

    let url = Config.hostUrl + 'users/sendWelcomeEmail'
    console.log('calling rest @', url, params);
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    // that.setState({isLoading: true});
    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          //'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
        // that.setState({isLoading: false});
        //console.log ('Network exception: ', e);

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }


  /// get users
  export function userFetch(that, params) {
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
        params.version = Config.version;
    let url = Config.hostUrl + 'users/info' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    // that.setState({isLoading: true});
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + params.access_token
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        // that.setState({isLoading: false});
        if (response && response.user) return response.user;
        return response;
      })
      .catch(e => {
        //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
        // that.setState({isLoading: false});
        //console.log ('Network exception: ', e);

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });
  }

  /// get users
  export function userRegForSocialLogin(that, params) {
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
        params.version = Config.version;
    let url = Config.hostUrl + 'users/register' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    // that.setState({isLoading: true});
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + params.access_token
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        // that.setState({isLoading: false});
        if (response && response.user) return response.user;
        return response;
      })
      .catch(e => {
        //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
        // that.setState({isLoading: false});
        //console.log ('Network exception: ', e);

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });
  }

  export function userRegisterFetch(that, params) {
    //params.portal = Config.portal;
    //params.platform = Config.platform;
    //params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    //    params.version = Config.version;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    // hash pwd
    let hashedPwd = sha1('userloginregister' + params.password);
    params.password = hashedPwd;

    //let url = Config.hostUrl + 'users/register';
    let url = Config.hostUrl + 'users/registrazioneUtente';

    // alert('calling rest @ ' + url + ', params:' + JSON.stringify(params));

    // that.setState({isLoading: true});
    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          //'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
        // that.setState({isLoading: false});
        // alert('Network exception: ' + JSON.stringify(e));

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          // alert('Returning null');
          return null;
        }
      });

  }
  export function confirmEmail(that, params) {

    //    params.version = Config.version;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    
    let url = Config.hostUrl + 'users/confirmEmail' + objectToURIParams(params);;

    console.log('calling rest @', url, params);

    // that.setState({isLoading: true});
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
        // that.setState({isLoading: false});

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }
  // export function sendCodeByEmail(that, params) {
  //   params.language = tr.userlng().toLowerCase();

  //   let url = Config.hostUrl + 'users/sendCodeByEmail' + objectToURIParams(params);

  //   console.log('calling rest @', url, params);

  //   // that.setState({isLoading: true});
  //   return fetch(
  //     url,
  //     {
  //       method: 'POST',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(params),
  //     }
  //   )
  //     .then((response) => checkStatus(that, response))
  //     .then((response) => {
  //       // that.setState({isLoading: false});
  //       return response;
  //     })
  //     .catch(e => {
  //       //sendLogs('-----------> Inside fetch of userLoginFetch ERRORRRR', response, 'end');
  //       // that.setState({isLoading: false});
  //       //console.log ('Network exception: ', e);

  //       if (e.message.indexOf("Network request failed") >= 0) {
  //         // DataManager.getInstance().setConnectionState(false);
  //         return null;
  //       }
  //     });

  // }
  /* Post End */


  export function validateCard(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/validateCard';
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        if (response.status == 'fail') {
          switch (Number(response.code)) {
            case 20: case 21: case 22:
              response.message = tr.t('cardValidateError');
              break;
            case 23: case 24: case 25:
              response.message = tr.t('cardValidationSysError');
              break;
            case 33:
              response.message = tr.t('cardValidationProviderError');
              break;
            default:
              break;
          }
        }
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  // export async function activateCard(access_token, cardId, nkey) {
  //   var myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  //   myHeaders.append("Authorization", `Bearer ${access_token}`);
  //   const params = {
  //     language: tr.userlng().toLowerCase(),
  //     portal: Config.portal,
  //     special: "0",
  //     nkey: nkey,
  //     mode: 'raw',
  //     validate: 1
  //   }

  
  //   var requestOptions = {
  //     method: 'POST',
  //     headers: myHeaders,
  //     redirect: 'follow'
  //   };
  
  //   const apiUrl = `${ApiSkiConfig.apiSkiUrl}api/v1/cards/${cardId}/activate${objectToURIParams(params)}`
  //   const response = await fetchData(apiUrl, requestOptions);
  //   return response;
  // }

  export function activateCard(that, access_token, cardId, nkey) {
    const params = {
      language: tr.userlng().toLowerCase(),
      portal: Config.portal,
      special: "0",
      nkey: nkey,
      mode: 'raw',
      validate: 1
    }
    const url = `${ApiSkiConfig.apiSkiUrl}api/v1/cards/${cardId}/activate${objectToURIParams1(params)}`
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        console.log('activate card response', response);
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function deleteCreditCard(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'payment/deleteCreditCard';
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export async function activateEnablingList(that, props) {
    const access_token = await cookies.get('access_token');
    const params = {
      cardId: props.cardId,
      nkey: props.nkey,
      choices: props.choices,
      photoLoaded: props.photoLoaded,
      photoValidated: props.photoValidated,
      forced: props.forced,
      special: props.special,
      portal: Config.portal,
      platform: Config.platform,
    }
    console.log('activateEnablingList params:', objectToURIParams(params));
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", `Bearer ${access_token}`);
  
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow',
      body: JSON.stringify(params)
    };

    let apiUrl = Config.hostUrl + 'service/activateEnablingList' + objectToURIParams(params);
    return fetch(
      apiUrl,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }
  

  export async function getCardOptions(cardID, nKey) {
    const access_token = await cookies.get('access_token');
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", `Bearer ${access_token}`);
    const params = {
      cardId: cardID,
      cardCode: nKey,
    }
    console.log('getCardOptions params:', objectToURIParams(params));
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
  
    try {
      let apiUrl = Config.hostUrl + 'service/getCardOptions' + objectToURIParams(params);
      const options = await fetch(apiUrl, requestOptions);
      return options.json();
    } catch (error) {
      console.error('Error getting card options:', error);
    }
  
  }

  export function getCreditCardInfo(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    params.portal = Config.portal;
    params.platform = Config.platform;
    let url = Config.hostUrl + 'payment/getCreditCardInfo' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response && response.status == 'fail' ? response : response[0];
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }


  export function getPartnerInfo(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'payment/getPartnerInfo' + objectToURIParams(params);
    // url = url.replace('/sci/','/BTQ/');//TODO: remove me after finalising 
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
          // 'Authorization': 'Bearer ' + 'RUFqbzdFTmdvakU4YW5jeEtjemFudjBr',

        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }


  export function checkUser(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'users/checkUser' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function checkCategory(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/checkCategory' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function getCounties(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'users/getCounties' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function getCountries(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'users/getCountries' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function checkIfCanBuyCard(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/checkIfCanAddItem' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function getServicePrice(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/getServicePrice' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function getTotalPriceForService(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/getTotalPriceForService' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function getDiscountForServices(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/getDiscountForServices' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function getDiscountForApp(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/getDiscountForApp' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }


  export function getServiceDescription(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/getServiceDescription' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function addToCart(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/addItemToShoppingCart';
    console.log('calling rest @', url, params);
    let convertedParams = addToCartToAddItemToShoppingCart(params);
    console.log('addToCartToAddItemToShoppingCart @convertedParams', convertedParams);

    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(convertedParams),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }


  export function create(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'workflow/create';
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function state(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'workflow/state';
    console.log('calling rest state @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function awsState(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    const url = `https://awsservices.mypass.technology/${Config.userTest ? "dev" : "prod"}/v1/wfstate`;
    console.log('calling rest awsState@', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify({ data: params }),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }
  export function getHelpMsg(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'workflow/getHelpMsg' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        //console.log('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }
  export function transition(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'workflow/transition';
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  //same endpoint as addToCart but different configuration to be transparent in the other parts
  export function addToCartByVoucher(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/addItemToShoppingCart';
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function buyAnotherCard(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/buyAnotherCard';
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function deleteCart(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/deleteShoppingCart';
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }


  export function deleteItemInShoppingCart(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/deleteItemInShoppingCart';
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }



  export function buyService(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/buySkiService';
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function updateUser(that, access_token, params) {
    //params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'users/updateUserSmart';
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  export function checkCart(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'service/getShoppingCart' + objectToURIParams(params);
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return getShoppingCartToCheckCartConverter(response);
      })
      .catch(e => {
        that.setState({ isLoading: false });
        console.warn('Network exception: ', e);
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  // LOGOUT! if user decides to  close the terms
  export function logout(that) {
    try {
      // fill storage w/ user data.
      userLogoutFetch(that).then((response) => {
        console.log(response);
        localStorage.clear();
        cookies.remove('access_token');
        console.log("it is unauthorized");
        return window.location.replace("/");
        // return this.props.history.push('/');
      });
    } catch (e) {
      console.log(e);
    }
  }
  export function checkStatus(that, response) {

    if (response.status == 401) { // unauthorized
      // that.setState({active: false});
      console.log("[" + response.status + "] checkStatus", response);
      // DataManager.getInstance().clear();

      //console.warn('unauthorized:', response.status, ', redirecting to login screen', that);
      //that.props.navigation.navigate('Login');
      // return response.json();
      logout(that);
    }
    if (response.status < 200 || response.status >= 300) {
      //console.warn('wrong network request response status:', response.status);
      // status not ok, we could take some extra action, here...
    }
    //console.log('checkStatus() - response:', response);
    return response.json();
  }

  export function statusMessage(type, message) {

    alert("[" + type + ']' + message)
  }


  export function luhncalc(str) {
    var odd = !(str).strlen % 2;
    let sum = 0;
    for (var i = 0; i < (str).strlen; ++i) {
      let n = 0 + str[i];
      var odd = !odd;
      if (odd) {
        sum += n;
      } else {
        let x = 2 * n;
        sum += x > 9 ? x - 9 : x;
      }
    }
    return (sum % 10 == 0);

  }



  /// AUTH FETCH FUNCTIONS

  // TO DO MORE ACCURATE :)
  // check if user is logged
  // @return bool status
  export function isLogged() {
    return _hasAccessToken();
  }

  // private 
  // check if access_token exist
  // return bool response
  function _hasAccessToken() {
    access_token = cookies.get('access_token');
    console.log("_hasAccessToken", _hasAccessToken);
    return (typeof access_token != 'undefined');
  }


  // LOGIN
  // @return object : response
  export function userLoginFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
        params.version = Config.version;

    // hash pwd
    let hashedPwd = sha1('userloginregister' + params.password);
    params.password = hashedPwd;


    let url = Config.hostUrl + 'users/login' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });
  }



  // LOGOUT
  // @return object : response
  export function userLogoutFetch(that, params) {

    let url = Config.hostUrl + 'users/logout' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }


  // CHANGE PASSWORD
  // @return object : response
  export function changeUserPasswordFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    // hash pwd
    let hashedPwd = sha1('userloginregister' + params.newPassword);
    params.newPassword = hashedPwd;

    //
    let url = Config.hostUrl + 'users/changePassword';

    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => {
        return checkStatus(that, response);
      })
      .then((response) => {
        return response;
      })
      .catch(e => {
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }

  export function getSkiers(that, params) {
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = Config.language;
        params.version = Config.version;
    let url = Config.hostUrl + 'service/getSkiers' + objectToURIParams(params);

    console.log('calling getSkiers @', url, params, "this is the passed token:", access_token);

    //that.setState({active: true});
    return fetch(
      url,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
          timeout: Config.timeoutFetch,
        },

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        console.log('getSkiers response', response);
        ///console.log('✓ ' + arguments.callee.toString().match(/function ([^\(]+)/)[1], 'response:', response);
        // that.setState({active: false});
        return response;
      })
      .catch(e => {
        console.log('getSkiers error', e);
        // that.setState({active: false});
        //console.log('Network exception: ', e);

        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });
  }

  // GET CARDS (SKIERS)
  // @return object : response
  export function getCardsFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
        params.version = Config.version;

    let url = Config.hostUrl + 'service/getCards' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'GET',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }


  // CHANGE AUTORENEW FLAG (SKIERS)
  // @return object : response
  export function modifyAutorenewFlagFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'service/modifyAutoRenewFlag' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }


  // CHANGE AUTORENEW FLAG (SKIERS)
  // @return object : response
  export function renewService(that, params) {

    // config
    params.portal = Config.portal;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'service/renewService';

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }

  // SEARCH CARDS 
  // @return object : response
  export function searchCardsFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
        params.version = Config.version;

    let url = Config.hostUrl + 'service/searchCard' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'GET',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }



  // DISABLE CARD
  // @return object : response
  export function disableCardFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'service/blockCard' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }



  // GET SKIER MOVEMENTS 
  // @return object : response
  export function getSkierMovementsFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.platform = Config.platform;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
        params.version = Config.version;

    let url = Config.hostUrl + 'service/getSkierMovements' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'GET',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        }
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }


  // UPLOAD SKIER PROFILE PIC
  // @return object : response
  export function updateSkierPictureFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'users/updateSkierPicture';

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }

  export function setSkierPostalCode(that, params) {

    // config
    params.portal = Config.portal;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'service/setSkierPostalCode';

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }



  // UPLOAD SKIER DOCUMENTS
  // @return object : response

  export function updateSkierDocumentFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'users/updateSkierDocument';

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }

  export function acceptMinorTreatment(that, params) {

    // config
    params.portal = Config.portal;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'privacy/acceptMinorTreatment';

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }


  // UPDATE USER INFO
  // @return object : response
  export function updateUserFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'users/updateUser' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }


  // changing partner activation status from enable to disable and viceversa
  export function updateStatusWalletPartner(that, access_token, params) {
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;
    let url = Config.hostUrl + 'users/updateStatusWalletPartner';
    // url = url.replace('/sci/','/BTQ/');//TODO: remove me after finalising 
    console.log('calling rest @', url, params);
    that.setState({ isLoading: true });
    return fetch(
      url,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),
      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        that.setState({ isLoading: false });
        return response;
      })
      .catch(e => {
        that.setState({ isLoading: false });
        if (e.message.indexOf("Network request failed") >= 0) {
          return null;
        }
      });
  }

  // /users/updateProfilePicture

  // UPLOAD USER PROFILE PIC
  // @return object : response

  export function updateProfilePictureFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'users/updateProfilePicture';

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }


  // DELETE USER
  // @return object : response
  export function deleteUserFetch(that, params) {

    // config
    params.portal = Config.portal;
    params.language = tr.userlng().toLowerCase();
    params.version = Config.version;

    let url = Config.hostUrl + 'users/delete' + objectToURIParams(params);

    console.log('calling rest @', url, params);

    return fetch(
      url,
      {
        method: 'POST',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        body: JSON.stringify(params),

      }
    )
      .then((response) => checkStatus(that, response))
      .then((response) => {
        return response;
      })
      .catch(e => {
        console.log(e);
        if (e.message.indexOf("Network request failed") >= 0) {
          // DataManager.getInstance().setConnectionState(false);
          return null;
        }
      });

  }





// WEBPACK FOOTER //
// ./src/libs/fetch.js